import { useState, useEffect } from 'react';
import useClientHydrated from '@charlietango/use-client-hydrated';

var ScriptStatus;
/**
 * Hook to load an external script. Returns true once the script has finished loading.
 *
 * @param url {string} url The external script to load
 * @param options {} options for hook
 * @param options.attributes {} attributes object for Script tag attributes
 * */

(function (ScriptStatus) {
  ScriptStatus["IDLE"] = "idle";
  ScriptStatus["LOADING"] = "loading";
  ScriptStatus["READY"] = "ready";
  ScriptStatus["ERROR"] = "error";
})(ScriptStatus || (ScriptStatus = {}));

function useScript(url, options) {
  var clientHydrated = useClientHydrated();
  var attributes = options == null ? void 0 : options.attributes;

  var _useState = useState(function () {
    if (clientHydrated) {
      var script = document.querySelector("script[src=\"" + url + "\"]");

      if (script && script.hasAttribute('data-status')) {
        return script.getAttribute('data-status');
      }
    }

    return url ? ScriptStatus.LOADING : ScriptStatus.IDLE;
  }),
      status = _useState[0],
      setStatus = _useState[1];

  useEffect(function () {
    if (!url) {
      setStatus(ScriptStatus.IDLE);
      return;
    }

    var script = document.querySelector("script[src=\"" + url + "\"]");

    if (!script) {
      script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.setAttribute('data-status', ScriptStatus.LOADING);

      if (attributes) {
        Object.keys(attributes).forEach(function (key) {
          var _script;

          (_script = script) == null ? void 0 : _script.setAttribute(key, attributes[key]);
        });
      }

      document.head.appendChild(script); // Ensure the status is loading

      setStatus(ScriptStatus.LOADING);

      script.onerror = function () {
        if (script) script.setAttribute('data-status', ScriptStatus.ERROR);
      };

      script.onload = function () {
        if (script) script.setAttribute('data-status', ScriptStatus.READY);
      };
    } else if (script.hasAttribute('data-status')) {
      setStatus(script.getAttribute('data-status'));
    }

    var eventHandler = function eventHandler(e) {
      setStatus(e.type === 'load' ? ScriptStatus.READY : ScriptStatus.ERROR);
    }; // Add load event listener


    script.addEventListener('load', eventHandler);
    script.addEventListener('error', eventHandler);
    return function () {
      if (script) {
        script.removeEventListener('load', eventHandler);
        script.removeEventListener('error', eventHandler);
      }
    };
  }, [url, attributes]);
  return [status === ScriptStatus.READY, status];
}

export default useScript;
export { ScriptStatus };
